
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/download/od/done",
      function () {
        return require("private-next-pages/download/od/done/index.tsx");
      }
    ]);
  